import type { IConfig } from '@/composables/request'

// 获取书籍详情
export function asyncGetBookInfo(novel_id: number | string) {
  return request({
    url: '/tapon/book',
    method: 'get',
    params: {
      novel_id,
    },
  })
}

// 获取章节列表
export function asyncGetBookArticles(novel_id: number, noLoad = false) {
  return request({
    url: '/tapon/book/articles',
    method: 'get',
    params: {
      novel_id,
    },
    noLoad,
  } as IConfig)
}

// 获取哪些章节已经购买
export function asyncGetBookArticlesIsUnlock(novel_id: number) {
  return request({
    url: '/tapon/book/consumed',
    method: 'get',
    params: {
      novel_id,
    },
  })
}

// 获取章节详情(解锁)
export function asyncGetBookArticle({
  chapter_id = 0,
  consume_confirm = 1,
}: {
  chapter_id: number | string
  consume_confirm?: number
}) {
  return request({
    url: '/tapon/book/article',
    method: 'get',
    params: {
      chapter_id,
      consume_confirm,
    },
    noMessage: true,
  } as IConfig)
}

// 章节预览
export function asyncGetBookArticlePreview({ chapter_id = 0 }: { chapter_id: number | string }) {
  return request({
    url: '/tapon/book/preview',
    method: 'get',
    params: {
      chapter_id,
    },
  })
}
